import { render, staticRenderFns } from "./voucherAd.vue?vue&type=template&id=2d3710c7&scoped=true"
import script from "./voucherAd.vue?vue&type=script&lang=js"
export * from "./voucherAd.vue?vue&type=script&lang=js"
import style0 from "./voucherAd.vue?vue&type=style&index=0&id=2d3710c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3710c7",
  null
  
)

export default component.exports